import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { ICondition, IRule } from '../../../../Models/tenant';
import { TenantService } from '../../../../Services/tenant.service';
import { Field } from '../Models';
import { ModuleService } from '../Services/module.service';
import { PackageService } from '../Services/package.service';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/autocomplete';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: "my-modules-condition",
    templateUrl: "./module.condition.component.html",
    styleUrls: ["./module.component.css"],
    imports: [MatFormField, MatLabel, MatSelect, FormsModule, MatOption, MatCheckbox, MatInput, MatButton, MatIcon]
})
export class ModuleConditionComponent implements OnInit {
    @Input() rule: IRule;
    @Input() condition: ICondition;
    @Input() conditionFields: Field[];
    @Input() listItemsCache: any[];
    @Input() disabled: boolean;

    selectedFieldType: string;
    valueOptions: any[] = [];

    operators: any = [
        { value: 0, label: "Is Equal To" },
        { value: 1, label: "Is Not Equal To" },
        //{ value: 2, label: "Is Greater Than" },
        //{ value: 3, label: "Is Greater Than Or Equal To" },
        //{ value: 4, label: "Is Less Than" },
        //{ value: 5, label: "Is Less Than Or Equal To" },
        //{ value: 6, label: "Is After (Date)" },
        //{ value: 7, label: "Is Before (Date)" },
        //{ value: 8, label: "Now Has Value" },
        //{ value: 9, label: "No Longer Has Value" },
        { value: 10, label: "All Are In" },
        { value: 11, label: "All Are Not In" },
        { value: 12, label: "Any Are In" },
        { value: 13, label: "Any Are Not In" }
    ];

    constructor(
        private readonly activatedRoute: ActivatedRoute,
        private readonly moduleService: ModuleService,
        private readonly tenantService: TenantService,
        private readonly packageService: PackageService,
        private readonly router: Router,
        public dialog: MatDialog,
        private readonly ref: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
        this.configureValueControl();
    }

    conditionFieldChanged() {
        this.condition.MultiItemName = this.conditionFields.filter((f) => f.FieldId === this.condition.PropertyName)[0].MultiFieldName;
        this.condition.Value = null;
        this.condition.ValueArray = null;
        this.configureValueControl();
    }

    configureValueControl() {
        const field = this.conditionFields.filter((f) => f.FieldId === this.condition.PropertyName)[0];

        if (field === undefined || field === null) {
            this.selectedFieldType = "text";
        } else {
            this.selectedFieldType = field.FieldUniqueId;

            switch (field.FieldUniqueId) {
                case "list":
                    this.condition.$type = "Airsweb.Utilities.BusinessRules.Entity.ConditionString, Airsweb.Utilities";

                    if (field.ListParams["ListAlias"] === undefined) {
                        this.selectedFieldType = "text";
                    } else {
                        this.selectedFieldType = "list";
                        this.setList(field.ListParams["ListAlias"]);
                    }

                    break;
                case "severitymatrix":
                    this.condition.$type = "Airsweb.Utilities.BusinessRules.Entity.ConditionString, Airsweb.Utilities";
                    this.selectedFieldType = "list";
                    this.setList("sevmatrix_default");
                    break;
                case "checkbox":
                case "signoff":
                    this.condition.$type = "Airsweb.Utilities.BusinessRules.Entity.ConditionBoolean, Airsweb.Utilities";
                    break;
                default:
                    this.condition.$type = "Airsweb.Utilities.BusinessRules.Entity.ConditionString, Airsweb.Utilities";
                    this.selectedFieldType = "text";
            }
        }
    }

    setList(listName: string) {
        if (this.listItemsCache[listName]) {
            this.setValueOptions(listName);
        } else {
            this.loadList(listName).subscribe(() => this.setValueOptions(listName));
        }
    }

    loadList(listName: string): Observable<any> {
        return this.tenantService.getListItems(["AIRSWEBLIST", listName]).pipe(
            mergeMap((r) => this.listItemsCache[listName] = r)
        )
    }

    setValueOptions(listName: string) {
        this.valueOptions = this.listItemsCache[listName];
        this.setConditionValueArray();
    }

    setConditionValueArray() {
        if (!this.condition.ValueArray && this.condition.Value && this.condition.Value.length > 0) {
            this.condition.ValueArray = this.condition.Value.split(",");
        }
    }

    onDeleteButtonClick() {
        this.deleteCondition();
    }

    deleteCondition() {
        this.rule.Conditions = this.rule.Conditions.filter((c) => c !== this.condition);
    }

    prettifyLabel(lbl: string): string {
        let op: string;
        if (!lbl) {
            console.log("label undefined");
            return "";
        }
        if (lbl.indexOf(":") > -1) {
            op = lbl.split(":")[1];
        } else {
            op = lbl;
        }

        return op.replace(/_/g, " ");
    }
}